import React, {  useEffect,useState } from "react";
import { getFeedBackUrl } from "utils/api";
import { observer } from "mobx-react-lite";
import useStores from "stores";
import { loginUrl } from "utils/api/ajax";
import { useHistory } from "react-router-dom";

import './index.scss'

const FeedBack = observer(() => {
  const { loginStore } = useStores();
  const [ feedbackUrl, setFeedbackUrl ] = useState('');
  const history = useHistory();
  useEffect(()=>{

    if(loginStore.isLogin){
      //意见反馈请求
      getFeedBackUrl()
      .then(res => {
        if(res.data.success) {
          setFeedbackUrl(res.data.result);
        }
      })
    }
    
  },[loginStore.isLogin])

  const handleFeedback = ()=>{
    if(loginStore.isLogin){
      window.open(feedbackUrl);
    } else {
      history.push(loginUrl);
    }
    
  }

  return (
    <div className='vop_home_message' onClick={handleFeedback} clstag="pageclick|keycount|VopOpenConsole_1611892618710|100">
        <img
          src="https://img11.360buyimg.com/imagetools/jfs/t1/208700/35/10344/5825/619c8ba9E0640fa5e/27b7035b02c34919.png"
          alt=""
        />
        <span>意见反馈</span>
      </div>
  );
})

export default FeedBack;


